<template>
  <div class="home">
    <div
      class="grid grid-cols-3 gap-8 m-auto mb-8 transition-all transform duration-500"
      :class="{
        'pt-48': !searchActive,
      }"
      style="max-width:1000px;">
      <div><of-input-text @keyup.prevent="searchContacts" v-model="this.contactSearch" xl shadow :placeholder="'Contact email or phone'" icon="users" /></div>
      <div><of-input-text @keyup.prevent="searchSubscriptions" v-model="this.subscriptionSearch" xl shadow :placeholder="'Subscription id'" icon="redo" /></div>
      <div><of-input-text @keyup.prevent="searchTransactions" v-model="this.paymentSearch" xl shadow :placeholder="'Transaction no'" icon="credit-card" /></div>
    </div>

    <template v-if="this.contacts">
      <app-contact-list shadow="shadow" :contacts="contacts" />
    </template>
    <template v-else-if="this.subscriptions">
      <div class="shadow bg-white rounded">
        <of-row cols="4" hover border v-for="(subscription, index) in this.subscriptions" :key="index">
          <slot>
            <div>{{ subscription.state }}</div>
            <div>{{ new Date(subscription.createdTs).toLocaleString() }}</div>
            <div>{{ subscription.paymentMethodType }}</div>
            <div>{{ subscription.nextDueDate }}</div>
          </slot>
          <template v-slot:body>
            <div class="m-4 mt-0 shadow rounded p-4">loading</div>
          </template>
        </of-row>
      </div>
    </template>
    <template v-else-if="this.payments">
      <app-payment-list shadow="shadow" :payments="payments" />
    </template>
  </div>
</template>

<script>
import axios from "axios";
import AppContactList from '../components/app/contacts/AppContactList.vue'
import AppPaymentList from '../components/app/payments/AppPaymentList.vue'

export default {
  name: "Home",
  components: {
    AppContactList,
    AppPaymentList,
  },
  data() {
    return {
      searchActive: false,
      contacts: null,
      contactSearch: '',
      subscriptions: null,
      subscriptionSearch: null,
      payments: null,
      paymentSearch: null,
    };
  },
  methods: {
    formatPhoneNo(msisdn, countryCode) {
      if (countryCode == 'DK') {
        if (msisdn.length == 10) {
          return `+45 ${msisdn.substring(2,6)} ${msisdn.substring(6,10)}`;
        }
      }

      return msisdn;
    },
    searchContacts() {
      this.searchActive = true;

      if (this.contactSearch == "") {
        this.contacts = null;
      } else {
        this.subscriptionSearch = '';
        this.subscriptions = null;
        this.paymentSearch = '';
        this.payments = null;

        axios
          .get(`${this.$store.state.OFconfig.api_payment_engine_url}/contacts?Search=${this.contactSearch}`, {
            headers: {
              Authorization: this.$store.state.OFconfig.api_payment_engine_token,
            }
          })
          .then((response) => {
            this.contacts = response.data;
          })
          .catch(error => {
            this.toastError(error);
            this.sendingEmail = false;
          });
      }
    },
    searchSubscriptions() {
      this.searchActive = true;

      if (this.subscriptionSearch == "") {
        this.subscriptions = null;
      } else {
        this.contactSearch = '';
        this.contacts = null;
        this.paymentSearch = '';
        this.payments = null;

        axios
          // .get(`${this.$store.state.OFconfig.api_payment_engine_url}/subscriptions?Search=${this.subscriptionSearch}`, {
          .get(`${this.$store.state.OFconfig.api_payment_engine_url}/subscriptions?pageNumber=1&pageSize=10&state=Active`, {
            headers: {
              Authorization: this.$store.state.OFconfig.api_payment_engine_token,
            }
          })
          .then((response) => {
            console.log(response.data.list);
            this.subscriptions = response.data.list;
          })
          .catch(error => {
            this.toastError(error);
            this.sendingEmail = false;
          });
      }
    },
    searchTransactions() {
      this.searchActive = true;

      this.subscriptionSearch = '';
      this.subscriptions = null;
      this.contactSearch = '';
      this.contacts = null;

      if (this.paymentSearch == "") {
        this.payments = null;
      } else {
        axios
          .get(`${this.$store.state.OFconfig.api_payment_engine_url}/payments?Search=${this.paymentSearch}`, {
            headers: {
              Authorization: this.$store.state.OFconfig.api_payment_engine_token,
            }
          })
          .then((response) => {
            this.payments = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  },
};
</script>
